import { StripeSubscriptionStatus } from '@business/entities/project/SubscriptionResponse';

export function getSubscriptionStatusName(status: StripeSubscriptionStatus) {
  switch (status) {
    case StripeSubscriptionStatus.active:
      return 'Active';
    case StripeSubscriptionStatus.canceled:
      return 'Canceled';
    case StripeSubscriptionStatus.incomplete:
      return 'Incomplete';
    case StripeSubscriptionStatus.incomplete_expired:
      return 'Incomplete Expired';
    case StripeSubscriptionStatus.past_due:
      return 'Past Due';
    case StripeSubscriptionStatus.trialing:
      return 'Trialing';
    case StripeSubscriptionStatus.unpaid:
      return 'Unpaid';
    default:
      return status;
  }
}

export function getSubscriptionStatusColor(status: StripeSubscriptionStatus) {
  switch (status) {
    case StripeSubscriptionStatus.active:
      return 'success';
    case StripeSubscriptionStatus.canceled:
      return 'info';
    case StripeSubscriptionStatus.incomplete:
      return 'danger';
    case StripeSubscriptionStatus.incomplete_expired:
      return 'danger';
    case StripeSubscriptionStatus.past_due:
      return 'danger';
    case StripeSubscriptionStatus.trialing:
      return 'danger';
    case StripeSubscriptionStatus.unpaid:
      return 'danger';
    default:
      return 'info';
  }
}
export function getTransactionStatusColor(status: string) {
  switch (status) {
    case 'Refunded':
      return 'dark';
    case 'Partial Refunded':
      return 'dark';
    case 'Paid':
      return 'success';
    case 'Failed':
      return 'danger';
    default:
      return 'info';
  }
}
